import {
    GET_AUTO_PROMOTION_SMS_STARTED,
    GET_AUTO_PROMOTION_SMS_SUCCESS,
    GET_AUTO_PROMOTION_SMS_FAILURE,
    UPDATE_AUTO_PROMOTION_SMS_STARTED,
    UPDATE_AUTO_PROMOTION_SMS_SUCCESS,
    UPDATE_AUTO_PROMOTION_SMS_FAILURE,
    REMOVE_ERROR_MESSAGE
} from "../../constants/autoPromotionSms/autoPromotionSms";



const businessData = JSON.parse(localStorage.getItem("business") || "{}");
const salonName = businessData.name || "Your Salon";

const initialState = {
    autoPromotionSmsList: [
        {
            type: "auto_sms",
            isActive: false,
            lastVisit: 30,
            message: `It's been a while! Treat yourself at ${salonName}. Enjoy 10% off your next service when you book this week!`
        },
        {
            type: "auto_sms",
            isActive: false,
            lastVisit: 60,
            message: `We miss seeing you at ${salonName}! Here's 20% off your next visit - come back and relax with us.`
        },
        {
            type: "auto_sms",
            isActive: false,
            lastVisit: 90,
            message: `It's been 3 months! We'd love to welcome you back to ${salonName}. Enjoy 25% off your next appointment - just for you!`
        },
    ],
    loading: false,
    error: null,
    message: null,
};

export default function autoPromotionSms(state = initialState, action) {
    switch (action.type) {
        case GET_AUTO_PROMOTION_SMS_STARTED:
            return {
                ...state,
                loading: false,
                error: null,
                message: null
            };
        case GET_AUTO_PROMOTION_SMS_SUCCESS:
            const newList = action.payload.data;
            const mergedList = state.autoPromotionSmsList.map(item => {
                const updatedItem = newList.find(newItem => newItem.lastVisit === item.lastVisit);
                return updatedItem ? { ...item, ...updatedItem } : item;
            });
            return {
                ...state,
                loading: false,
                autoPromotionSmsList: mergedList,
                error: null
            };
        case GET_AUTO_PROMOTION_SMS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        case UPDATE_AUTO_PROMOTION_SMS_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        case UPDATE_AUTO_PROMOTION_SMS_SUCCESS:
            const updatedSms = action.payload.data;
            let newAutoPromotionSmsList = state.autoPromotionSmsList.map(sms =>
                sms.lastVisit === updatedSms.lastVisit ? { ...sms, ...updatedSms } : sms
            );
            return {
                ...state,
                loading: false,
                autoPromotionSmsList: newAutoPromotionSmsList,
                message: "Auto Promotion SMS updated successfully",
                error: null
            };
        case UPDATE_AUTO_PROMOTION_SMS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: null
            };

        case REMOVE_ERROR_MESSAGE: {
            return {
                ...state,
                loading: false,
                error: null,
                message: null
            };
        }

        default:
            return {
                ...state
            };
    }
}